module.exports = new __parcel__URL__("lobster.2b4a4d94.svg").toString();